<!-- 右侧工具栏 -->
<template>
    <div :class="isOpen ? 'topo-arg on' : 'topo-arg off'">
        <p class="title">节点属性</p>
        <el-form label-width="80px" v-if="curType==='text'" :model="form" class="form" size="small">
            <el-form-item label="内容">
                <el-input v-model="form.text" @blur="handleText"></el-input>
            </el-form-item>
            <el-form-item label="文字大小">
                <el-select v-model="form.fontSize" allow-create filterable placeholder="请选择大小" @change="handleFontSize">
                    <el-option label="12" :value="12"></el-option>
                    <el-option label="14" :value="14"></el-option>
                    <el-option label="16" :value="16"></el-option>
                    <el-option label="18" :value="18"></el-option>
                    <el-option label="20" :value="20"></el-option>
                    <el-option label="22" :value="22"></el-option>
                    <el-option label="24" :value="24"></el-option>
                    <el-option label="26" :value="26"></el-option>
                    <el-option label="28" :value="28"></el-option>
                    <el-option label="30" :value="30"></el-option>
                    <el-option label="32" :value="32"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="文字粗细">
                <el-select v-model="form.fontWeight" allow-create placeholder="请选择" @change="handleFontWeight">
                    <el-option label="200" :value="200"></el-option>
                    <el-option label="400" :value="400"></el-option>
                    <el-option label="600" :value="600"></el-option>
                    <el-option label="800" :value="800"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="颜色">
                <el-color-picker v-model="form.color" @change="handleColor"></el-color-picker>
            </el-form-item>
        </el-form>

        <el-form label-width="80px" v-if="curType==='line'" :model="lineForm" class="form" size="small">
            <el-form-item label="线条粗细">
                <el-input v-model.number="lineForm.width" @blur="handleWidth"></el-input>
            </el-form-item>
            <el-form-item label="旋转角度">
                <el-input v-model.number="lineForm.rotate" @blur="handleRotate"></el-input>
            </el-form-item>
            <el-form-item label="颜色">
                <el-color-picker v-model="lineForm.color" @change="handleLineColor"></el-color-picker>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import bus from "@/utils/bus";
export default {
    data() {
        return {
            form: {
                text: '',
                fontSize: '',
                fontWeight: '',
                color: '',
            },
            isOpen: false,
            currentNode: {},
            node_type: '',

            lineForm: {
                width: 1,
                color: '',
                rotate: '',
            },
            curType: '',
        };
    },

    components: {},

    computed: {},
    created() {
        bus.$on('clickNode', (cur)=>{
            this.currentNode = cur
            if(!cur) {
                this.isOpen = false
                return
            }
            this.curType = cur.type
            if(cur.type === 'text') {
                this.isOpen = true
                this.initData()
            }else if(cur.type === 'line') {
                this.isOpen = true
                this.initDataLine()
            }else{
                this.isOpen = false
            }
        })
    },
    methods: {
        initData() {
            this.node_type = this.currentNode.node.dataset.type
            let ele = this.currentNode
            // 文本节点
            if(this.node_type === "NB" || this.node_type === 'WB') {
                let text = ele.text()
                let fontSize = ele.font('size')
                let color = ele.attr("fill")
                let fontWeight = ele.font('weight') || 200
                this.form = Object.assign(this.form, {text, fontSize, color, fontWeight})
            }
        },
        initDataLine() {
            this.node_type = this.currentNode.node.dataset.type
            let ele = this.currentNode
            // 线条节点
            if(this.node_type === "LINE_D") {
                let color = ele.attr("stroke");
                let width = ele.attr("stroke-width")
                this.lineForm = Object.assign(this.lineForm, {color, width})
            }
        },
        handleText() {
            let val = this.form.text;
            if(val.trim() == '') return
            this.currentNode.text(val.trim())
        },
        handleFontSize() {
            let val = this.form.fontSize
            if(isNaN(val)) return
            this.currentNode.font("size", val)
        },
        handleFontWeight() {
            let val = this.form.fontWeight
            if(isNaN(val)) return
            this.currentNode.font("weight", val)
        },
        handleColor(val) {
            this.currentNode.fill(val)
        },
        handleWidth() {
            let val = this.lineForm.width
            if(isNaN(val)) return
            this.currentNode.stroke({ width: val })
        },
        handleLineColor(val) {
            this.currentNode.stroke({ color: val })
        },
        handleRotate() {
            let val = this.lineForm.rotate
            if(isNaN(val)) return
            this.currentNode.rotate(val)
        }
    }
}

</script>
<style lang='less' scoped>
.topo-arg{
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 103;
    width: 240px;
    background-color: #fff;
    transition: all .4s;
    .title{
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        background-color: #f4f4f4;
    }
    .form{
        margin: 10px 10px 0;
    }
    &.off{
        right: -240px;
    }
    &.on{
        right: 0;
        .topo-arg-nav i{
            margin-left: 5px;
            border-color:transparent transparent transparent #fff;
            &::after{
                top: -10px;
                left: -13px;
                border-color:transparent transparent transparent #266cba;
            }
        }
    }
}
</style>